// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SuperAdminSchoolTournaments .table-responsive {
  overflow: visible;
}

.SuperAdminSchoolTournaments .react-datepicker-popper {
  z-index: 10000 !important;
}
`, "",{"version":3,"sources":["webpack://./src/views/SuperAdminApp/School/Tournaments/SuperAdminSchoolTournaments.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".SuperAdminSchoolTournaments .table-responsive {\n  overflow: visible;\n}\n\n.SuperAdminSchoolTournaments .react-datepicker-popper {\n  z-index: 10000 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
